// --- smooth scroll --------------

// lenis smooth scroll
const lenis = new Lenis({
  smoothWheel: true, // Smooth wheel behavior
  smoothTouch: false, // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  // Ignore elements with the class 'scroll-section' (or any other class you use)
  ignore: (el) => el.classList.contains("scroll-section"),
});

lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});

gsap.ticker.lagSmoothing(0);

// --- smooth scroll --------------

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header-wrapper .header .header-wrapper");
  const scrollClass = "bg-white";

  if (!header) return;

  const path = window.location.pathname;

  // Home OR About page
  const isHomeOrAbout =
    path === "/" ||
    path.includes("/pages/about") ||
    document.body.classList.contains("home");

  if (isHomeOrAbout) {
    
    window.addEventListener("scroll", function () {
      if (window.scrollY > 0) {
        header.classList.add(scrollClass);
      } else {
        header.classList.remove(scrollClass);
      }
    });
  } else {
 
    header.classList.add(scrollClass);
  }
});